import api from './api';

const getAuth = (campaignId) => {
  return api.get(`api/auth?campaignId=${campaignId}`);
};

export default getAuth;
